import { render, staticRenderFns } from "./GiftCouponForm.vue?vue&type=template&id=3cb50aa7"
import script from "./GiftCouponForm.vue?vue&type=script&lang=js"
export * from "./GiftCouponForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports